// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { S } from './styles';

export type Direction = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

interface TooltipsProps extends React.ComponentPropsWithoutRef<'div'>{
  direction: Direction;
}

function Tooltips({ children, direction, ...props }: TooltipsProps): JSX.Element {
  return (
    <S.RelativeContainer>
      <S.Container direction={direction} {...props}>
        {(direction === 'topLeft' || direction === 'topRight') &&
      <S.Triangle direction={direction}/>}
        <S.RelativeContainer>
          <S.TextBox>{children}</S.TextBox>
        </S.RelativeContainer>
        {(direction === 'bottomLeft' || direction === 'bottomRight') &&
      <S.Triangle direction={direction}/>}
      </S.Container>
    </S.RelativeContainer>
  )
}

export { Tooltips as default };
